import {connect} from '@gisatcz/ptr-state';

import Select from '../../../../../../state/Select';

import presentation from './presentation';

const mapStateToProps = state => {
	return {
		style: Select.styles.getByKey(state, 'zonesExposure'),
	};
};

export default connect(mapStateToProps)(presentation);
